import { render, staticRenderFns } from "./ValuationSubjectWizardUpdateProject.vue?vue&type=template&id=77e5fefa&"
import script from "./ValuationSubjectWizardUpdateProject.vue?vue&type=script&lang=js&"
export * from "./ValuationSubjectWizardUpdateProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports